document.querySelectorAll('carousel-slider[data-mobile-rotate-delay]').forEach((carousel) => {
  if (carousel.hasAttribute('data-auto-rotate-initialized')) return;
  carousel.setAttribute('data-auto-rotate-initialized', '');
  
  const delay = parseInt(carousel.dataset.mobileRotateDelay, 10) || 5000;
  const rtl = document.dir === 'rtl';
  let isPaused = false;
  let pauseTimer = null;
  let advanceTimer = null;

  const advance = () => {
    if (!theme.mediaMatches.sm &&
        !isPaused &&
        carousel.slider &&
        carousel.slides &&
        carousel.slides.length > 1 &&
        !carousel.hasAttribute('inactive') &&
        theme.elementUtil.isInViewport(carousel)) {
      const currentIndex = Math.round(Math.abs(carousel.slider.scrollLeft) / carousel.slideSpan);
      const nextIndex = (currentIndex + 1) % carousel.slides.length;
      const scrollPos = nextIndex * carousel.slideSpan;
      carousel.slider.scrollTo({ left: rtl ? -scrollPos : scrollPos, behavior: 'smooth' });
    }
    if (carousel.isConnected) {
      advanceTimer = setTimeout(advance, delay);
    }
  };

  advanceTimer = setTimeout(advance, delay);

  carousel.addEventListener('touchstart', () => {
    clearTimeout(pauseTimer);
    isPaused = true;
  }, { passive: true });

  carousel.addEventListener('touchend', () => {
    clearTimeout(pauseTimer);
    pauseTimer = setTimeout(() => { isPaused = false; }, delay);
  }, { passive: true });
});
